import type { GridSortDirection, GridSortModel } from '@mui/x-data-grid-pro'

/**
 * Converts a GridSortModel into a key-value object that can be used as URLSearchParams
 */
export function convertSortModelToSearchParams(sortModel: GridSortModel): Record<string, string> {
  const sortParams: Record<string, string> = sortModel.reduce((acc, sortItem) => {
    return { ...acc, [`sort.${sortItem.field}`]: sortItem.sort }
  }, {})

  return sortParams
}

/**
 * Converts URLSearchParams into a valid GridSortModel
 *
 * When a sort is not present in the search params, we apply the initial state value
 */
export function convertSearchParamsToSortModel(): GridSortModel | null {
  const searchParams = new URLSearchParams(globalThis.location.search)
  const sortFilterModelFromSearchParams = Array.from(searchParams.entries())
    .filter(([sortKey]) => {
      const [id] = sortKey.split('.')

      return id === 'sort'
    })
    .reduce((acc, [sortKey, sortDirection]) => {
      const [, field] = sortKey.split('.')

      const sortItem: GridSortModel[0] = { field, sort: sortDirection as GridSortDirection }

      return [...acc, sortItem]
    }, [] as GridSortModel)

  return sortFilterModelFromSearchParams.length > 0 ? sortFilterModelFromSearchParams : null
}
